module.exports = __webpack_public_path__ + "img/j01-min.cf690812.png";